/* global FWP */

const $ = window.jQuery;

export default class FaceWPSort {
  constructor() {
    this.selectors = {
      table: '.js-products-table-sort',
      column: '.js-products-table-sort-column',
      sortFacetName: '[data-type="sort"][data-name^="sort_"]',
    };

    this.classes = {
      isDesc: 'is-desc',
      isActive: 'is-active',
    };

    this.orderOptions = ['asc', 'desc'];
  }

  init() {
    if (typeof FWP === 'undefined') {
      return;
    }
    this.bindClickEvents();

    document.addEventListener('facetwp-loaded', () => {
      this.setDefaultSorting();
      this.updateCurrentColumnSettings();
    });
  }

  bindClickEvents() {
    $(document).on('click', this.selectors.column, event => {
      event.preventDefault();
      this.sortColumn($(event.currentTarget));
    });
  }

  sortColumn(sortColumn) {
    const order = sortColumn.attr('data-order');
    const sortField = sortColumn.attr('data-sort-field');
    const facetName = $(this.selectors.sortFacetName).attr('data-name');
    const orderValue = `${sortField}_${order}`;

    FWP.facets[facetName] = [orderValue];
    FWP.setHash();
    FWP.fetchData();
  }

  updateCurrentColumnSettings() {
    const table = $(this.selectors.table);
    const sort = table.data('sort');
    const sortValues =
      FWP.facets[sort].length === 1 ? FWP.facets[sort][0].split('_') : [];
    if (sortValues.length) {
      const newOrder = sortValues[1] === 'asc' ? 'desc' : 'asc';
      const currentColumn = $(`[data-sort-field="${sortValues[0]}"`);
      $(this.selectors.column)
        .removeClass(this.classes.isActive)
        .removeClass(this.classes.isDesc);
      currentColumn
        .addClass(this.classes.isActive)
        .attr('data-order', newOrder);

      if (newOrder === 'asc') {
        currentColumn.addClass(this.classes.isDesc);
      }
    }
  }

  setDefaultSorting() {
    const table = $(this.selectors.table);
    const sort = table.data('sort');
    if (!FWP.facets[sort].length) {
      FWP.facets[sort] = ['producer_asc'];
      FWP.setHash();
    }
  }
}
